import { colors } from "@areahub/theme";

/**
 *  Colors determined from [here](https://www.arcgis.com/home/webmap/viewer.html?url=https://services.arcgis.com/XG15cJAlne2vxtgt/ArcGIS/rest/services/National_Risk_Index_Annualized_Frequency_Heat_Wave/FeatureServer/1&source=sd)
 *  */
const STOPS = [
  -9999,
  colors.blueGray[200],
  0,
  colors.green[300],
  0.73,
  colors.amber[300],
  2.6,
  colors.orange[500],
  5.9,
  colors.red[500],
  11.8,
  colors.red[600],
];

/**
 *  Legend determined from [here](https://www.arcgis.com/home/webmap/viewer.html?url=https://services.arcgis.com/XG15cJAlne2vxtgt/ArcGIS/rest/services/National_Risk_Index_Annualized_Frequency_Heat_Wave/FeatureServer/1&source=sd)
 */
const getLegendRows = () => {
  return [
    ["> 11.8 – 24", 11],
    ["> 5.9 – 11.8", 9],
    ["> 2.6 – 5.9", 7],
    ["> 0.73 – 2.6", 5],
    ["0 – 0.73", 3],
    ["Not Applicable", 1],
  ].map((row) => ({
    icon: "draw-polygon",
    label: row[0] === "Not Applicable" ? row[0] : row[0] + " events/yr",
    color: STOPS[row[1] as number],
  }));
};

export const heatWaves = {
  stops: STOPS,
  props: getLegendRows(),
};
